import { Link } from 'react-router-dom';

const statusColors = {
  active: { bg: '#e8f5ee', color: '#1a6b45' },
  retired: { bg: '#f5f5f5', color: '#666' },
  seeking: { bg: '#fef3e2', color: '#c8820a' },
};

export default function PlayerCard({ player }) {
  const sc = statusColors[player.status] || statusColors.active;
  const initials = player.full_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

  return (
    <Link to={`/players/${player.id}`} style={{ display: 'block', background: 'white', borderRadius: 8, border: '1px solid #e5e5e5', padding: '1.25rem', transition: 'box-shadow 0.15s' }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
      <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
        <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#e8f5ee', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', fontWeight: 600, color: '#1a6b45', fontSize: '1rem', flexShrink: 0 }}>
          {player.profile_photo ? <img src={player.profile_photo} alt={player.full_name} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} /> : initials}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 600 }}>{player.full_name}</h3>
            {player.is_verified && <span style={{ color: '#1a6b45', fontSize: '0.8rem' }}>✓</span>}
          </div>
          <div style={{ fontFamily: 'sans-serif', fontSize: '0.8rem', color: '#666', marginTop: 2 }}>{player.position} · {player.nationality}</div>
          {player.current_club && <div style={{ fontFamily: 'sans-serif', fontSize: '0.8rem', color: '#999', marginTop: 2 }}>{player.current_club}</div>}
          <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <span style={{ ...sc, padding: '2px 8px', borderRadius: 20, fontSize: '0.72rem', fontFamily: 'sans-serif' }}>{player.status}</span>
            {player.age && <span style={{ background: '#f5f5f5', color: '#666', padding: '2px 8px', borderRadius: 20, fontSize: '0.72rem', fontFamily: 'sans-serif' }}>Age {player.age}</span>}
          </div>
        </div>
      </div>
      {player.bio && <p style={{ marginTop: '0.75rem', fontSize: '0.85rem', color: '#666', lineHeight: 1.5, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{player.bio}</p>}
    </Link>
  );
}
